import React, { useState, Fragment, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Toolbar from "@mui/material/Toolbar";
import { alpha } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { twoDecimalPlaces } from "../../utils/utilsHandlerFunctions";
import { httpSuperAdmin } from "../../Apis/commonApis";
import { ShowSwal } from "../../utils/alertSwal";

export default function EnhancedTableToolbar(props) {
  const history = useHistory();
  const {
    numSelected,
    selected,
    tableName,
    tableforDeleteActInact,
    selectedFullObject,
    getSetting,
    settingId,
    setSelectedFullObject,
    clear,
  } = props;

  useEffect(() => {
    getInvHeaders();
  }, []);

  const [show, setShow] = useState(false);
  const [popupStatus, setPopupStatus] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [taxRate, setTaxRate] = useState("");
  const [currency, setCurrency] = useState("");
  const [symbol, setSymbol] = useState("");
  const [invoiceHeaderDetails, setInvoiceHeaderDetails] = useState({});
  const [templateName, setTemplateName] = React.useState("");

  const [gbpExchangeRate, setGbpExchangeRate] = useState("");
  const handleClose = () => {
    setShow(false);
    setSelectedFullObject([]);
    clear();
  };
  const handleShow = (text) => {
    setShow(true);
    setPopupStatus(text);
  };

  function actionHandler() {
    if (popupStatus === "Delete") {
      if (tableforDeleteActInact === "Template") deleteTemplate(selected);
      if (tableforDeleteActInact === "Currency") deleteCurrency(selected);
      if (tableforDeleteActInact === "Taxes") deleteTaxes(selected);
    }
    if (popupStatus === "Inactive") {
      if (tableforDeleteActInact === "Template")
        activeInactiveTemplate(selected, "Inactive");
      if (tableforDeleteActInact === "Currency")
        activeInactiveCurrency(selected, "Inactive");
      if (tableforDeleteActInact === "Taxes")
        activeInactiveTaxes(selected, "Inactive");
    }
    if (popupStatus === "Activate") {
      if (tableforDeleteActInact === "Template")
        activeInactiveTemplate(selected, "Active");
      if (tableforDeleteActInact === "Currency")
        activeInactiveCurrency(selected, "Active");
      if (tableforDeleteActInact === "Taxes")
        activeInactiveTaxes(selected, "Active");
    }
  }

  const deleteTemplate = (id) => {
    let data = {
      settingId: settingId,
      templateId: id,
    };
    axios({
      url: `${process.env.REACT_APP_SUPERADMIN_BASEURL}/deleteTemplate`,
      method: "POST",
      headers: { Authorization: localStorage.getItem("superadmin_token") },
      data: data,
    })
      .then((res) => {
        getSetting();
        setPopupStatus("");
      })
      .catch((error) => console.log(`Error: ${error}`));
  };

  const getInvHeaders = async (id) => {
    let res = await httpSuperAdmin(`getInvHeaders`, null);
    if (res.status) {
      setInvoiceHeaderDetails(res.data);
    }
  };

  const deleteCurrency = async (id) => {
    let data = {
      settingId: settingId,
      currencyId: id,
    };
    let res = await httpSuperAdmin(`deleteCurrency`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      setPopupStatus("");
    }
  };

  const deleteTaxes = async (id) => {
    let data = {
      settingId: settingId,
      taxId: id,
    };
    let res = await httpSuperAdmin(`deleteTaxes`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      setPopupStatus("");
    }
  };

  const activeInactiveTemplate = async (id, status) => {
    let data = {
      settingId: settingId,
      templateId: id,
      status: status,
    };
    let res = await httpSuperAdmin(`markTemplate`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      setPopupStatus("");
    }
  };

  const activeInactiveCurrency = async (id, status) => {
    let data = {
      settingId: settingId,
      currencyId: id,
      taxStatus: status,
    };
    let res = await httpSuperAdmin(`markCurrency`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      setPopupStatus("");
    }
  };

  const activeInactiveTaxes = async (id, status) => {
    let data = {
      settingId: settingId,
      taxId: id,
      taxStatus: status,
    };
    let res = await httpSuperAdmin(`markTaxes`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      setPopupStatus("");
    }
  };

  const editTaxes = async () => {
    let data = {
      settingId: settingId,
      taxId: selectedFullObject[0]?._id,
      country: country ? country : selectedFullObject[0]?.country,
      taxRate: taxRate
        ? twoDecimalPlaces(taxRate)
        : twoDecimalPlaces(selectedFullObject[0]?.taxRate),
      state: state ? state : selectedFullObject[0]?.state,
    };
    let res = await httpSuperAdmin(`editTaxes`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      handleClose();
    }
  };

  const editCurrency = async () => {
    let data = {
      settingId: settingId,
      currencyId: selectedFullObject[0]?._id,
      currency: currency ? currency : selectedFullObject[0]?.currency,
      symbol: symbol ? symbol : selectedFullObject[0]?.symbol,
      gbpExchangeRate: gbpExchangeRate
        ? twoDecimalPlaces(gbpExchangeRate)
        : twoDecimalPlaces(selectedFullObject[0]?.gbpExchangeRate),
    };
    let res = await httpSuperAdmin(`editCurrency`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      handleClose();
    }
  };

  const editTemplate = async () => {
    let data = {
      settingId: settingId,
      templateId: selectedFullObject[0]?._id,
      creationDate: new Date(),
      templateName: templateName
        ? templateName
        : selectedFullObject[0]?.templateName,
    };
    let res = await httpSuperAdmin(`editTemplate`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getSetting();
      handleClose();
    }
  };

  return (
    <Fragment>
      {numSelected > 0 && (
        <Toolbar
          sx={{
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            ...(numSelected > 0 && {
              bgcolor: (theme) =>
                alpha(
                  theme.palette.primary.main,
                  theme.palette.action.activatedOpacity
                ),
            }),
          }}
        >
          <Typography
            sx={{ flex: "1 1 100%" }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>

          <div className="float-end btns_head">
            {/* <button className="btn btn-theme btn-sm">Create Groups</button> */}
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  disabled={numSelected !== 1}
                  onClick={() => {
                    handleShow(tableName);
                  }}
                >
                  Edit
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    handleShow("Delete");
                  }}
                >
                  Delete
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    handleShow("Inactive");
                  }}
                >
                  Make Inactive
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    handleShow("Activate");
                  }}
                >
                  Re-Activate
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Toolbar>
      )}

      {popupStatus === "Delete" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton2>
            <Modal.Title>
              <span>Delete Invoice</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <p>Are you sure you want to delete this {tableName} ?</p>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button className="btn submitBtn" onClick={handleClose}>
                No
              </button>
              <button
                className="btn submitBtn"
                onClick={() => {
                  actionHandler();
                }}
              >
                Yes
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {popupStatus === "Inactive" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton2>
            <Modal.Title>
              <span>Inactive Plan</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <p>Are you sure you want to Inactive this {tableName} ?</p>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button className="btn submitBtn" onClick={handleClose}>
                No
              </button>
              <button
                className="btn submitBtn"
                onClick={() => {
                  actionHandler();
                }}
              >
                Yes
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {popupStatus === "Activate" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton2>
            <Modal.Title>
              <span>Activate Plan</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <p>Are you sure you want to Activate this {tableName} ?</p>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button className="btn submitBtn" onClick={handleClose}>
                No
              </button>
              <button
                className="btn submitBtn"
                onClick={() => {
                  actionHandler();
                }}
              >
                Yes
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {popupStatus === "Edit Taxes" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton2>
            <Modal.Title>
              <span>Edit Taxes</span>
              <div className="d-flex">
                <button className="btn" onClick={handleClose}>
                  Close
                </button>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Country</label>
                  <input
                    onChange={(e) => setCountry(e.target.value)}
                    type="text"
                    defaultValue={selectedFullObject[0]?.country}
                    required
                    className="form-control"
                  />
                </div>
                {selectedFullObject?.[0]?.country === "United States" && (
                  <div className="col-md-12 mb-3">
                    <label className="mb-1">State</label>
                    <input
                      onChange={(e) => setState(e.target.value)}
                      type="text"
                      defaultValue={selectedFullObject[0]?.state}
                      required
                      className="form-control"
                    />
                  </div>
                )}
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Tax Rate</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={twoDecimalPlaces(
                      selectedFullObject[0]?.taxRate
                    )}
                    required
                    onChange={(e) => setTaxRate(e.target.value)}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  editTaxes();
                  // setSelectedFullObject([])
                }}
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {popupStatus === "Edit Currency" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton2>
            <Modal.Title>
              <span>Edit Currency</span>
              <div className="d-flex">
                <button className="btn" onClick={handleClose}>
                  Close
                </button>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Currency</label>
                  <input
                    onChange={(e) => setCurrency(e.target.value)}
                    type="text"
                    required
                    defaultValue={selectedFullObject[0]?.currency}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Symbol</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={selectedFullObject[0]?.symbol}
                    required
                    onChange={(e) => setSymbol(e.target.value)}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">GBP Exchange Rate</label>
                  <input
                    type="text"
                    defaultValue={twoDecimalPlaces(
                      selectedFullObject[0]?.gbpExchangeRate
                    )}
                    className="form-control"
                    required
                    onChange={(e) => setGbpExchangeRate(e.target.value)}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  editCurrency();
                }}
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {popupStatus === "Edit Template" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton2>
            <Modal.Title>
              <span>Edit Tempalte</span>
              <div className="d-flex">
                <button className="btn" onClick={handleClose}>
                  Close
                </button>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Template Name</label>
                  <input
                    onChange={(e) => setTemplateName(e.target.value)}
                    type="text"
                    defaultValue={selectedFullObject[0]?.templateName}
                    required
                    className="form-control"
                  />
                </div>
                {/* <div className="col-md-12 mb-3">
                <label className="mb-1">Tax Rate</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  onChange={(e) => setTaxRate(e.target.value)}
                />
              </div> */}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  editTemplate();
                }}
              >
                Update
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </Fragment>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  selected: PropTypes.array,
  selectedOptions: PropTypes.array,
  tableName: PropTypes.string.isRequired,
  selectedFullObject: PropTypes.array,
};
